import React from 'react'
import "./feature.css"
const Feature = ({title , text , structureClass}) => {
  return (
    <div className={"gpt3__features-container-feature"}>
      <div className="gpt3__features-container-feature-title">
      {/* for spacing */}
        <div /> 

        <h1>{title}</h1>
      </div>
      <div className="gpt3__features-container-feature-text">
        <p>{text}</p>
      </div>
    </div>
  )
}

export default Feature